import { useState } from 'react'
import { useContext, useContextSelector } from 'use-context-selector'

import { PromoPageStateContext } from 'states/PromoPageState/PromoPageStateProvider'
import { saveSection } from 'states/PromoPageState/reducer'
import { SectionState } from 'states/PromoPageState/state'
import { ConferenceType } from 'sections/PromoSection/pages/ConferencesPage/types'
import { BlockWrap } from 'components/AdminV2/BlockWrap/BlockWrap'
import { AdminAddElemButton } from 'components/AdminV2/UI/AddElemButton/AdminAddElemButton'
import { AdminInput } from 'components/AdminV2/UI/Input/AdminInput'
import { AdminSaveButton } from 'components/AdminV2/UI/SaveButton/AdminSaveButton'
import { AdminTextArea } from 'components/AdminV2/UI/TextArea/AdminTextArea'
import { useCalendar } from 'utils/hooks/useCalendar'
import { ConferenceData, SectionName } from 'types/types'

import { AdminCalendar } from './Calendar/AdminCalendar'
import { ConferenceBlockItem } from './ConferenceBlockItem/ConferenceBlockItem'

import s from './ConferencesBlock.module.scss'

export const ConferencesBlock = () => {
  const state = useContextSelector(PromoPageStateContext, (context) =>
    context.state.sections.find((section) => section.type === SectionName.conferences),
  ) as SectionState

  const ctx = useContext(PromoPageStateContext)

  const { state: calendarState } = useCalendar()

  const [localPromoState, setLocalPromoState] = useState<SectionState>(state)
  const [title, setTitle] = useState(localPromoState.title)
  const [description, setDescription] = useState((localPromoState.content as ConferenceData).description)

  const conferences: ConferenceType[] =
    (localPromoState.content as ConferenceData).conferenceData[calendarState.selectedYear]?.[
      calendarState.selectedMonth.monthIndex
    ]?.[calendarState.selectedDate.dayNumber] ?? []

  const addConferenceHandler = () => {
    const state = { ...localPromoState }
    let selectedYear = (state.content as ConferenceData).conferenceData[calendarState.selectedYear]

    if (selectedYear === undefined) {
      selectedYear = {}
    }

    if (selectedYear[calendarState.selectedMonth.monthIndex] === undefined) {
      selectedYear[calendarState.selectedMonth.monthIndex] = {}
    }

    if (selectedYear[calendarState.selectedMonth.monthIndex][calendarState.selectedDate.dayNumber] === undefined) {
      selectedYear[calendarState.selectedMonth.monthIndex][calendarState.selectedDate.dayNumber] = []
    }

    selectedYear[calendarState.selectedMonth.monthIndex][calendarState.selectedDate.dayNumber].push({
      index: selectedYear[calendarState.selectedMonth.monthIndex][calendarState.selectedDate.dayNumber].length,
      title: '',
      description: '',
      link: '',
      linkToVideo: '',
      startDate: calendarState.selectedDate.date,
      endDate: calendarState.selectedDate.date,
    })
    ;(state.content as ConferenceData).conferenceData[calendarState.selectedYear] = selectedYear

    setLocalPromoState(state)
  }

  const handleSave = () => {
    const state = { ...localPromoState }

    state.title = title
    ;(state.content as ConferenceData).description = description

    setLocalPromoState(state)
    ctx.dispatch(saveSection(state))
  }

  const handleConferenceSave = (conference: ConferenceType) => {
    const state = { ...localPromoState }

    ;(state.content as ConferenceData).conferenceData[calendarState.selectedYear][
      calendarState.selectedMonth.monthIndex
    ][calendarState.selectedDate.dayNumber][conference.index] = conference

    setLocalPromoState(state)
    ctx.dispatch(saveSection(state))
  }

  return (
    <>
      <AdminInput label="Заголовок" labelWeight={600} value={title} onChange={setTitle} />
      <AdminTextArea value={description} onChange={setDescription} label="Описание" />
      <AdminSaveButton onClick={handleSave} text="Сохранить заголовок и описание" />

      <AdminCalendar state={calendarState} />

      {conferences.length > 0 && <h4 className={s.title}>Конференции:</h4>}

      {conferences?.map((conference, index) => (
        <BlockWrap
          key={`${conference.title}-${conference.startDate}`}
          type={SectionName.conferences}
          text={index + 1 + '. ' + conference.title}
          textFontSize={16}
        >
          <ConferenceBlockItem
            index={index}
            calendarState={calendarState}
            localPromoState={localPromoState}
            setLocalPromoState={setLocalPromoState}
            existingConferences={conferences}
            conference={conference}
            handleSave={handleConferenceSave}
          />
        </BlockWrap>
      ))}

      <AdminAddElemButton text="Добавить конференцию" onClick={addConferenceHandler} />
    </>
  )
}
